import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      <div className="container">
        <header className="privacy-header">
          <h1>Política de Tratamiento de Datos</h1>
          <p className="privacy-subtitle">
            Fiesta del Tendero de Magangué - Comercio Unido
          </p>
        </header>

        <div className="privacy-content">
          <section className="privacy-section">
            <h2>Marco Legal</h2>
            <p>
              Dando cumplimiento a lo dispuesto en la <strong>Ley estatutaria 1581 de 2012</strong> y a su 
              <strong> Decreto Reglamentario 1377 de 2013</strong>, el grupo Comercio Unido, organizador de 
              la Fiesta del Tendero de Magangué, adopta la presente política para el tratamiento de datos 
              personales, la cual será informada a todos los titulares de los datos recolectados o que en 
              el futuro se obtengan en el ejercicio de las actividades académicas, culturales, comerciales 
              o laborales.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Compromiso de Comercio Unido</h2>
            <p>
              De esta manera, Comercio Unido manifiesta que garantiza los derechos de la privacidad, 
              la intimidad, el buen nombre y la autonomía, en el tratamiento de los datos personales, 
              y en consecuencia todas sus actuaciones se regirán por los principios de:
            </p>
            <ul className="privacy-list">
              <li><strong>Legalidad</strong></li>
              <li><strong>Finalidad</strong></li>
              <li><strong>Libertad</strong></li>
              <li><strong>Veracidad o calidad</strong></li>
              <li><strong>Transparencia</strong></li>
              <li><strong>Acceso y circulación restringida</strong></li>
              <li><strong>Seguridad y confidencialidad</strong></li>
            </ul>
            <p>
              Todas las personas que, en desarrollo de diferentes actividades culturales, académicas, 
              contractuales, comerciales, laborales, entre otras, sean permanentes u ocasionales, 
              llegaran a suministrar a Comercio Unido cualquier tipo de información o dato personal, 
              podrá conocerla, actualizarla y rectificarla.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Declaraciones y Autorizaciones</h2>
            <p>
              Actuando en mi propio nombre y representación, realizo las siguientes declaraciones 
              y autorizaciones:
            </p>

            <div className="authorization-item">
              <h3>a. Autorización General</h3>
              <p>
                Autorizo de manera libre, voluntaria, previa, expresa e informada a Comercio Unido 
                que conforman la Fiesta del Tendero de Magangué y a sus terceros aliados para que 
                recolecten, almacenen, usen, circulen, y en general, traten los datos personales 
                que aquí entrego.
              </p>
            </div>

            <div className="authorization-item">
              <h3>b. Finalidades del Tratamiento</h3>
              <p>
                Declaro conocer que mis datos personales aquí suministrados serán utilizados 
                específicamente para:
              </p>
              <ol className="privacy-numbered-list">
                <li>
                  <strong>La Organización del evento</strong> Fiesta del Tendero y tener un mejor 
                  control del ingreso exclusivo a la misma.
                </li>
                <li>
                  <strong>Hacer analítica</strong> para fines estadísticos, así como para un mejor 
                  entendimiento de las comunidades impactados por Comercio Unido desde la Fiesta del Tendero.
                </li>
                <li>
                  <strong>Contactarme</strong> vía correo electrónico, mensaje de texto, llamada o vía 
                  WhatsApp con el fin de presentarme futuras oportunidades.
                </li>
                <li>
                  <strong>Consulten, soliciten o verifiquen</strong> mi información financiera, en especial 
                  la información sobre mis activos, bienes, multas, sanciones o derechos ante entidades 
                  públicas o privadas, que se encuentren en buscadores públicos o privados, redes sociales 
                  o publicaciones físicas o electrónicas, ya sea en Colombia o en el exterior.
                </li>
              </ol>
            </div>

            <div className="authorization-item">
              <h3>c. Autorización de Imagen y Experiencia</h3>
              <p>
                Permito el registro de mi imagen y experiencia a Comercio Unido y sus terceros colaboradores 
                en el desarrollo del evento de la Fiesta del Tendero de Magangué y demás actividades que se 
                realicen entorno a los objetivos de Comercio Unido para aparecer en diferentes publicaciones 
                de páginas web, redes sociales, publicidad o informes de seguimiento del evento.
              </p>
            </div>

            <div className="authorization-item">
              <h3>d. Cesión de Derechos</h3>
              <p>
                Por lo anterior cedo a Comercio Unido y quienes conforman este grupo todos los derechos 
                sobre la imagen e información suministrada.
              </p>
            </div>

            <div className="authorization-item">
              <h3>e. Uso de Imagen y Datos Sensibles</h3>
              <p>
                Declaro conocer que el grupo Comercio Unido y sus aliados podrán hacer uso de mi imagen, 
                nombre, historia, para lo relacionado con comunicaciones internas, externas y en sitios 
                oficiales de Comercio Unido, Fiesta del Tendero de Magangué y sus aliados, así como para 
                la finalidad de realizar campañas informativas a través de diferentes medios audiovisuales.
              </p>
              <p className="sensitive-data-notice">
                <strong>Importante:</strong> Entendiendo que dicha información, bajo la ley de protección 
                de datos, es considerada como un Dato Personal Sensible y que no estoy en la obligación 
                de autorizar su tratamiento.
              </p>
            </div>

            <div className="authorization-item">
              <h3>f. Autorización Integral</h3>
              <p>
                Autorizo al grupo Comercio Unido y a sus aliados para, usar, modificar, compartir, difundir, 
                publicar mi imagen, nombre y apellidos e historia, y declaro que cuento con las calidades 
                y/o autorizaciones necesarias por parte de las personas que participan en las imágenes para 
                compartirlas, autorizar su uso, modificación y divulgación a aliados, al Grupo y por parte 
                del Grupo.
              </p>
            </div>
          </section>

          <section className="privacy-section contact-section">
            <h2>Contacto</h2>
            <p>
              Para ejercer sus derechos como titular de datos personales o para cualquier consulta 
              relacionada con esta política, puede contactarnos a través de los canales oficiales 
              de la Fiesta del Tendero de Magangué.
            </p>
          </section>
        </div>

        <div className="privacy-footer">
          <p>
            <strong>Comercio Unido - Fiesta del Tendero de Magangué</strong>
          </p>
          <p>
            Esta política de tratamiento de datos está vigente desde la fecha de publicación 
            y se actualiza conforme a los cambios normativos aplicables.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;